export const btagLocalStorageKey = 'referrals'
export const seoAccount = '654421_44B727F95F044AD482A0E3A2B3398401'
export const mgFlashGames = 'https://quickfire.gcontent.eu'
export const utmSourceSessionStorageKey = 'UTM_SOURCE'
export const utmMediumSessionStorageKey = 'UTM_MEDIUM'
export const utmCampaignSessionStorageKey = 'UTM_CAMPAIGN'
